export { default } from "./CarWhiteBgSecond";
